import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAllOoklaData } from '@api/ookla';

import { extractQueryParams } from '@utils/common';

import { OOKLA_MEASUREMENTS_ALL } from '@constants/queryKeys';

export const useQueryAllOoklaData = () => {
	const {
		accessPermission: {
			assetConsumerOrganizationAdministrator,
			networkOperatorOrganizationAdministrator,
			assetOwnerOrganizationAdministrator,
		},
	} = useAppSelector(auth);

	const isAllowed = (
		assetConsumerOrganizationAdministrator ||
		networkOperatorOrganizationAdministrator ||
		assetOwnerOrganizationAdministrator
	);

	const { data, isInitialLoading, isLoading, isFetching } = useQuery({
		queryKey: [OOKLA_MEASUREMENTS_ALL],
		queryFn: extractQueryParams(getAllOoklaData),
		enabled: [isAllowed],
	});

	return {
		allOoklaData: data || [],
		isInitialLoading,
		isLoading,
		isFetching,
	};
};
